import { Capacitor } from '@capacitor/core';

/**
 * Onde a pessoa libera permissões no aparelho (o texto muda entre Android e iPhone).
 *   settingsPath('notifications') → "Configurações do Android › Apps › TicketCar › Notificações"
 *                                 → "Ajustes do iPhone › TicketCar › Notificações"
 */
export const isIos = () => Capacitor.getPlatform() === 'ios';

const PATHS = {
  android: {
    notifications: 'Configurações do Android › Apps › TicketCar › Notificações',
    location: 'Configurações do Android › Apps › TicketCar › Permissões',
    preciseLocation: 'Configurações do Android › Apps › TicketCar › Permissões › Localização (precisa)',
  },
  ios: {
    notifications: 'Ajustes do iPhone › TicketCar › Notificações',
    location: 'Ajustes do iPhone › TicketCar › Localização',
    preciseLocation: 'Ajustes do iPhone › TicketCar › Localização (ligue "Localização Exata")',
  },
};

/** @param {'notifications' | 'location' | 'preciseLocation'} what */
export const settingsPath = (what) => PATHS[isIos() ? 'ios' : 'android'][what];
